import React, { useState } from "react";
import { Pane } from "evergreen-ui";
import { useQuery } from "@apollo/react-hooks";
import { typeQueries } from "../../utils/typeQueries";
import { useThrottle } from "../../utils/useThrottle";

export const Autocomplete = ({ type, onChoose, multi, value }) => {
  const { GET_DATA, fieldNames, typeName } = typeQueries(type);
  const [fulltext, setFulltext] = useState("");
  const [search, setSearch] = useThrottle("", 1000, value => {
    setFulltext(value);
  });
  const { data, error, loading } = useQuery(GET_DATA, {
    variables: {
      filters: [
        {
          field: "__fulltext",
          values: [fulltext]
        }
      ],
      limit: 10
    }
  });
  if (loading) return <Pane>Ładownaie...</Pane>;
  if (error) return <Pane>Error.</Pane>;
  return (
    <>
      <input value={search} onChange={setSearch} />
      {data[typeName]
        .filter(el => JSON.stringify(el).includes(search))
        .map(el => {
          return (
            <div
              key={el._id}
              onClick={() => {
                if (multi) {
                  if (value.length && value.some(val => val._id === el._id)) {
                    // uncheck
                    onChoose(
                      value
                        .map(el => ({
                          _id: el._id,
                          value: el.value
                        }))
                        .filter(val => val._id !== el._id)
                    );
                  } else {
                    // check
                    console.log(value);
                    const cleanedValue = value.length
                      ? value.map(el => ({
                          _id: el._id,
                          value: el.value
                        }))
                      : [];
                    console.log(cleanedValue);
                    console.log(
                      cleanedValue.concat([
                        {
                          _id: el._id,
                          value: el[fieldNames[0]]
                        }
                      ])
                    );
                    onChoose(
                      cleanedValue.concat([
                        {
                          _id: el._id,
                          value: el[fieldNames[0]]
                        }
                      ])
                    );
                  }
                } else {
                  onChoose({
                    _id: el._id,
                    value: el[fieldNames[0]]
                  });
                }
              }}
            >
              {el[fieldNames[0]]}
              {multi
                ? value.length && value.some(val => val._id === el._id)
                  ? "checked"
                  : ""
                : value && value._id === el._id
                ? "checked"
                : ""}
            </div>
          );
        })}
    </>
  );
};
